import React, { useRef, Fragment, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import {
  Grid,
  MenuItem,
  Select,
  Typography,
  Divider,
  IconButton,
  Collapse,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { KeyboardArrowUp, KeyboardArrowDown } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  bold: {
    fontWeight: 600,
  },
}));

export default function DetalleTrea(props) {
  const {
    register,
    errors,
    defaultItem,
    ctl,
    watch,
    setValue,
    tipo,
    personas,
  } = props;
  const classes = useStyles();
  const options = [
    { idestatus: 9, label: "Activo" },
    { idestatus: 10, label: "Inactivo" },
  ];
  const [expanded, setExpanded] = useState(false);
  const [expanded1, setExpanded1] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [data, setData] = useState([]);
  // const [value, setValue] = React.useState(options[0]);
  const [inputValue, setInputValue] = React.useState("");
  const [ctll, setCtl] = useState({
    personas: [],
  });
  const pageStyle = "@page { size: 8.5 in,hyphens:auto }";
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const handleExpandClick1 = () => {
    setExpanded1(!expanded1);
  };

  return (
    <React.Fragment>
      <Grid container className={classes.root} spacing={2}>
        {/* <div> */}
        {/* <React.Fragment> */}

        <Grid item md={5} xs={5}>
          <Typography variant="body2" className={classes.bold}>
            FECHA DE INICIO:
          </Typography>
          <Typography variant="body2">{ctl.fecha_inicio || "N/D"}</Typography>
        </Grid>
        <Grid item md={4} xs={4}>
          <Typography variant="body2" className={classes.bold}>
            FECHA DE TÉRMINO:
          </Typography>
          <Typography variant="body2"> {ctl.fecha_termino || "N/D"}</Typography>
        </Grid>
        <Grid item md={3} xs={3}>
          <Typography variant="body2" className={classes.bold}>
            HORAS:
          </Typography>
          <Typography variant="body2">
            {tipo
              ? tipo == "seguimiento"
                ? ctl.nhoras_seguimiento
                : ctl.nhoras_incidencia
              : "N/D"}
          </Typography>
        </Grid>
        <Grid container item md={12} xs={12}>
          <Grid item xs={6}>
            <Typography variant="body2" className={classes.bold}>
              EXTERNOS:
            </Typography>
            <Typography variant="body2">{ctl.involucrados}</Typography>
          </Grid>
          {ctl?.nseguimiento && (
            <Grid item xs={6}>
              <Typography variant="body2" className={classes.bold}>
                TIPO DE SEGUIMIENTO:
              </Typography>
              <Typography variant="body2">{ctl.nseguimiento}</Typography>
            </Grid>
          )}
        </Grid>

        <Grid item md={12} xs={12}>
          <Typography variant="body2" className={classes.bold}>
            MIEMBROS DE EQUIPO:
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleExpandClick1}
            >
              {expanded1 ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </Typography>

          <Collapse in={expanded1} timeout="auto" unmountOnExit>
            {personas
              ? personas.map(
                  (persona, index) => (
                    <React.Fragment>
                      <Typography variant="body2">
                        {index + 1 + ". " + persona.nombre}
                      </Typography>
                      <Divider />
                    </React.Fragment>
                  )
                  // )
                )
              : "N/D"}
          </Collapse>
        </Grid>
        <Grid item md={12} xs={12}>
          <Typography variant="body2" className={classes.bold}>
            DESCRIPCIÓN:
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleExpandClick}
            >
              {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </Typography>

          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Typography variant="body2">
              {tipo
                ? tipo == "seguimiento"
                  ? ctl.observaciones
                  : ctl.descripcion
                : "N/D"}
            </Typography>
          </Collapse>
        </Grid>

        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
